import React, { useContext, useEffect, useState } from 'react'; 
import cl from './ContainerAdd.module.css' 
import Container from "../../../../assets/Icon/Container";
import BLicon from "../../../../assets/Icon/BLicon";
import USD from "../../../../assets/Icon/USD";
import BookingNum from "../../../../assets/Icon/BookingNum";
import Number from "../../../../assets/Icon/Number";
import Remove from "../../../../assets/Icon/TimeB";
import Ship from "../../../../assets/Icon/Ship"; 
import Seal from "../../../../assets/Icon/Seal"; 
import { AppContext } from '../../../../providers/appProvider';
import { selectDistatntionStyle } from './selectDistatntionStyle';
import { selectStyle } from './selectStyle';
import Select from "react-select";
import DistatntionSelect from './DistatntionSelect';
import DateSelect from '../../../UI/Inputs/DateSelect';
import Plus from '../../../../assets/Icon/Plus';
import Kilogram from '../../../../assets/Icon/Kilogram';
import tbl from '../../../../assets/Style/Table.module.css' 
import { useContainerPrice } from "../../../../hooks/useContainerPrice";

const AddContainerModal = ({ containerService, defaultContainer, isOpen, onClose }) => {
    const containerResetData = {
        id: 0,
        container_number: "",
        bl_number: "",
        booking_number: "",
        ship_name: "",
        sender_city_id: 0,
        reciever_city_id: 0,
        sender_country_id: 0,
        reciever_country_id: 0,
        container_price_id: 0,
        agent_id: 0,

        total_price: 0,
        other_price: 0,
        frast_price: 0,
        thc_price: 0,

        is_transit: 0,
 
        client_total_price: 0,
        client_other_price: 0,
        client_frast_price: 0,
        client_thc_price: 0,

        client_land_other_price: 0,
        land_other_price: 0,

        land_type_id: 0,
        shipper_id: 0,
        marine_line_id: 0,
        land_type_id: 0,
        send_at: "",
        open_at: "",
        taken_at: "",
        entry_at: "",
        status_id: 1,
        total_price: 0,
        seal_number: "",
        voyage_number: "",
        gross_weight: 0,
        frast_price: 0,
        thc_price: 0,
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "30px", 
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };
    
    const { ContainerPriceService } = useContainerPrice(20, true);
    const [cargos, setCargos] = useState([]);

    const initialTransitOptions = [
        { value: 0, label: 'არა' },
        { value: 1, label: 'კი' }, 
    ]; 

    const initialTypeOptions = [
        { value: 0, label: '------' },
        { value: 1, label: 'Სარკინიგზო' },
        { value: 2, label: 'კონტეინერ მზიდი' },
        { value: 3, label: 'Საცალო' },
    ];

    const [typeTransitOptions, setTypeTransiOptions] = useState(initialTransitOptions);

    const [containerPrice, setContainerPrice] = useState({});

    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
 
    const addCargo = () => {
        setCargos([...cargos, {  name: "", personal: "", email: "", mobile: "", car_info: "", other_info: "", cargo_price: 0, vin: "", }]);
    };

    const removeCargo = (index) => {
        const list = [...cargos];
        list.splice(index, 1);
        setCargos(list); 
    };

    const handleInputChange = async (e, index) => {
        const { name, value } = e.target;
        const list = [...cargos];
        list[index][name] = value;
        setCargos(list);
    };

    const handleInputInt = async (e, index) => {
        const { name, value } = e.target;
        const list = [...cargos];
        list[index][name] = parseInt(value, 10);  
        setCargos(list); 
    };

    const [newContainer, setNewContainer] = useState(defaultContainer == null ? containerResetData : defaultContainer);
    const [isFirstValidated, setIsFirstValidated] = useState(false);
    const [validates, setValidates] = useState({});

    const { appState, app } = useContext(AppContext);
    const shippers = appState.shippers.map((shipper) => ({ value: shipper.id, label: shipper.name }));
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

    const validateContainer = (container) => {
        const messages = {};

        if (container.container_number.length < 2) {
            messages.container_number = { message: 'მიუთითეთ კონტაინერი ნომერი', isValid: false };
        }

        if (container.bl_number.length < 2) {
            messages.bl_number = { message: 'მიუთითეთ bl ნომერი', isValid: false };
        }

        if (container.booking_number.length < 2) {
            messages.booking_number = { message: 'მიუთითეთ booking ნომერი', isValid: false };
        }

        if (container.marine_line_id < 1) {
            messages.marine_line_id = { message: 'აირჩიე საზღვაო ხაზი', isValid: false };
        }

        if (container.shipper_id < 1) {
            messages.shipper_id = { message: 'აირჩიე შიპერი', isValid: false };
        }

        if (container.agent_id < 1) {
            messages.agent_id = { message: 'აირჩიე აგენტი', isValid: false };
        }

        if (container.ship_name.length < 2) {
            messages.ship_name = { message: 'მიუთითეთ გემის სახელი', isValid: false };
        }

        if (container.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (container.sender_city_id < 1) {
            messages.sender_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (container.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (container.reciever_city_id < 1) {
            messages.reciever_city_id = { message: 'სავალდებულოა', isValid: false };
        } 


        if (container.send_at.length < 1) {
            messages.send_at = { message: 'სავალდებულოა', isValid: false };
        } 

        cargos.forEach((cargo, i) => {
            if (cargo.name.length < 2) {
                messages['name' + i] = { message: 'მიუთითეთ სახელი გვარი', isValid: false };
            }
            if (cargo.vin.length < 2) {
                messages['vin' + i] = { message: 'მიუთითეთ ვინ-კოდი', isValid: false };
            }
            if (cargo.car_info.length < 2) {
                messages['car_info' + i] = { message: 'შეავსეთ ავტომობილის მონაცემები', isValid: false };
            } 
        });

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateContainer(newContainer);
    };

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateContainer(newContainer);
        }
    }, [newContainer, isFirstValidated]);

    const updateContainerListStatus = async (priceId, containerId) => {
        try {
          const updatedStatus = [{ id: containerId, status: "added" }];
          
          const result = await ContainerPriceService.updateContainerStatuses(
            parseInt(priceId),
            updatedStatus
          );
          
        } catch (error) {
          console.error("Save failed:", error);
        }
        ContainerPriceService.fetchList();
    }

    const saveHandle = async () => {

    let isValidate = validateContainer(newContainer);

    /*
    try {
        const found = await containerService.searchByBl(newContainer.bl_number, 5);
        console.log("this is found", found)
        console.log(found.length)
        if (found.length > 0) {
            isValidate = false;
            app.setError("ასეთი BL# უკვე რეგისტრირებულია სისტემაში, გთხოვთ გადაამოწმეთ!");
            console.log("აქ უნდა გამოიტანოს")
        }
    } catch (err) {
        console.error("BL lookup failed:", err);
    }

    */

    if (client_total_price < company_total_price) {
        isValidate = false;
        app.setError("კომპანიის გადასახდელი მეტია კლიენტის გადასახდელისა");
    }
    if (company_total_price < 1) {
        isValidate = false;
        app.setError("კომპანიის გადასახდელი ერთი ველი მაინც უნდა იყოს შევსებული");
    }

    if (isValidate) {
        try {
        await containerService.add({ ...newContainer, cargos });
        await updateContainerListStatus(
            newContainer.container_price_id,
            newContainer.container_number
        );
        onClose();
        } catch (error) {
        console.error("Error:", error);
        app.setError("Operation failed: " + error.message);
        }
    } else {
        setIsFirstValidated(true);
    }
    };


    const handleContainerChange = async (event) => {
        let val = event.target.value;
        setNewContainer(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handleContainerChangeInt = async (event) => {
        let val = parseInt(event.target.value, 10);
        setNewContainer(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; 
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
    };

    const handleFocus = (e) => { 
        if (e.target.value === '0') {
            setNewContainer({
                ...newContainer,
                [e.target.name]:  ''
              });
        }
    };

    const handleBlur = (e) => { 
        if (e.target.value === '') {
          let val = convertToInt(0);
            setNewContainer({
              ...newContainer,
              [e.target.name]:  val
            });
        };  
    };

    const handleFocusCargo = (e, index) => { 
        const { name, value } = e.target;
        const list = [...cargos];

        if (e.target.value === '0') { 
            list[index][name] = '';  
            setCargos(list);  
        }
    };

    const handleBlurCargo =  (e, index) => {  
        const { name, value } = e.target;
        const list = [...cargos];
 
        if (value === '') {
          let val = convertToInt(0); 
          list[index][name] = val;  
          setCargos(list); 
        };  
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const getTransportPrice = (sender_city_id, receiver_city_id, marine_line_id, agent_id, send_at) => {
    
        return new Promise((resolve, reject) => {
            // Convert send_at to a Date object
            const sendDate = new Date(send_at);

            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);

                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.marine_line.id === marine_line_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult); 
            }
        });
    };
    

  
    const getTransportPriceExtra = (sender_city_id, receiver_city_id, land_type_id, agent_id, send_at) => {
    
        return new Promise((resolve, reject) => {
            const sendDate = new Date(send_at);
    
            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);
    
                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.type_id === land_type_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult);
            }
        });
    };

    


    useEffect(() => {

        if (newContainer.sender_city_id > 0 || newContainer.send_at.length > 1) { 
            var reciever = newContainer.reciever_city_id
 
            const priceResponse = getTransportPrice(newContainer.sender_city_id, reciever, newContainer.marine_line_id, newContainer.agent_id, newContainer.send_at);
            priceResponse.then(result => {
                setNewContainer(prevState => ({
                    ...prevState,
                    thc_price: result.thc_price,
                    frast_price: result.frast_price, 
                    other_price: result.other_price, 

                    client_thc_price: result.client_thc_price,
                    client_frast_price: result.client_frast_price, 
                    client_other_price: result.client_other_price, 
                    container_price_id: result.id, 
                }));
                setContainerPrice(result);
            })
            .catch(err => {
                setNewContainer(prevState => ({
                    ...prevState,
                    thc_price: 0,
                    frast_price: 0, 
                    other_price: 0, 

                    client_thc_price: 0,
                    client_frast_price: 0, 
                    client_other_price: 0, 
                })); 
            });


            if (newContainer.final_destination_city_id > 0 || newContainer.send_at.length > 1) {
                
                reciever = newContainer.final_destination_city_id

                const priceResponse = getTransportPriceExtra(newContainer.reciever_city_id, reciever, newContainer.land_type_id, newContainer.agent_id, newContainer.send_at);
                priceResponse.then(result => {
                    setNewContainer(prevState => ({
                        ...prevState,
                        land_price: result.total_price, 
                        land_other_price: result.other_price, 
    
                        client_land_price: result.client_total_price, 
                        client_land_other_price: result.client_other_price, 
                        container_price_id: result.id, 
                    }));
                    
                    setContainerPrice(result);
                })
                .catch(err => {
                    setNewContainer(prevState => ({
                        ...prevState,
                        land_price: 0, 
                        land_other_price: 0, 
    
                        client_land_price: 0, 
                        client_land_other_price: 0,
                    })); 
                }); 
            }
        } else {
            /*setNewContainer(prevState => ({
                ...prevState,
                total_price: 0,
                thc_price: 0,
                frast_price: 0, 
                other_price: 0, 

                client_total_price: 0,
                client_thc_price: 0,
                client_frast_price: 0, 
                client_other_price: 0, 
            })); */
        }
    }, [newContainer.reciever_city_id, newContainer.sender_city_id, newContainer.marine_line_id, newContainer.land_type_id, newContainer.final_destination_city_id, newContainer.agent_id, newContainer.send_at]);

    const [client_total_price, setClientTotalPrice] = useState(0);
    const [company_total_price, setCompanyTotalPrice] = useState(0);

    useEffect(() => {
        calculateTotalPriceClient();
        calculateTotalPriceCompany();
    }, [newContainer]);

    const calculateTotalPriceClient = () => {
        const total = 
            parseFloat(newContainer.client_frast_price || 0) +
            parseFloat(newContainer.client_thc_price || 0) +
            parseFloat(newContainer.client_other_price || 0) +
            parseFloat(newContainer.client_land_price || 0) +
            parseFloat(newContainer.client_land_other_price || 0);
        setClientTotalPrice(total);
    };
    const calculateTotalPriceCompany = () => {
        const total = 
            parseFloat(newContainer.frast_price || 0) +
            parseFloat(newContainer.thc_price || 0) +
            parseFloat(newContainer.other_price || 0) +
            parseFloat(newContainer.land_price || 0) +
            parseFloat(newContainer.land_other_price || 0);
            setCompanyTotalPrice(total);
    };


    return (
        <div className={cl.containerBox} >

            <div className={cl.containerItem} style={{ marginBottom: '15px' }}>

                <div className={ validates && validates.container_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={cl.input}
                            id="container_number" name="container_number" value={newContainer.container_number} onChange={handleContainerChange} autoComplete="off" 
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <Container />
                        </div>
                    </div>
                    <label htmlFor="container_number">კონტეინერი</label>
                </div>

                <div className={validates && validates.bl_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="bl_number" name="bl_number" 
                            value={newContainer.bl_number} onChange={handleContainerChange} autoComplete="off" 
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <BLicon />
                        </div>
                    </div>
                    <label htmlFor="bl_number">BL ნომერი</label>
                </div>

                <div className={validates && validates.booking_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="booking_number" name="booking_number" 
                            value={newContainer.booking_number} onChange={handleContainerChange} autoComplete="off"
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <BookingNum />
                        </div>
                    </div>
                    <label htmlFor="booking_number">Booking ნომერი</label>
                </div>

                <div className={validates && validates.seal_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="seal_number" name="seal_number" 
                            value={newContainer.seal_number} onChange={handleContainerChange} autoComplete="off"
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <Seal />
                        </div>
                    </div>
                    <label htmlFor="seal_number">Seal ნომერი</label>
                </div>

                <div className={validates && validates.voyage_number ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="voyage_number" name="voyage_number" 
                            value={newContainer.voyage_number} onChange={handleContainerChange} autoComplete="off"
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <Number />
                        </div>
                    </div>
                    <label htmlFor="voyage_number">Voyage ნომერი</label>
                </div>

                <div className={validates && validates.ship_name ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={cl.input} id="ship_name" name="ship_name" 
                            value={newContainer.ship_name} onChange={handleContainerChange} autoComplete="off" 
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }}
                        />
                        <div className={cl.crmIcon}>
                            <Ship />
                        </div>
                    </div>
                    <label >გემის სახელი</label>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>

                <div className={validates && validates.shipper_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <Select
                        styles={validates && validates.shipper_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={shippers}
                        placeholder=""
                        value={shippers.find(option => option.value === newContainer.shipper_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                shipper_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >შიპერი</label>
                </div>
 
                <div  className={validates && validates.marine_line_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <Select
                        styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        placeholder=""
                        options={marines}
                        value={marines.find(option => option.value === newContainer.marine_line_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                marine_line_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >საზღვაო ხაზი</label> 
                </div>


                <div  className={validates && validates.agent_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <Select
                        styles={validates && validates.agent_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        placeholder=""
                        options={agents}
                        value={agents.find(option => option.value === newContainer.agent_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                agent_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >აგენტი</label> 
                </div>
 

                <div className={cl.groupInput}>
                    <Select
                        styles={validates && validates.status_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={appState.container_statuses}
                        value={appState.container_statuses.find(option => option.value === newContainer.status_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                status_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                        placeholder="სტატუსი"
                        isDisabled
                    />
                    <label>სტატუსი</label>
                </div>


            </div>
            
            <div className={cl.containerItem} style={{ marginBottom: '15px' }}>
                
                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.sender_country_id}
                        childId={newContainer.sender_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }));
                        }}
                        join={"country_id"}
                        label="გამოსვლის პორტი"
                        placeholder="- -"
                        placeholderSub="- - - - "
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                    />
                </div>
                
                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.reciever_country_id}
                        childId={newContainer.reciever_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }));
                        }}
                        join={"country_id"}
                        label="შემოსვლის პორტი"
                        placeholder="- -"
                        placeholderSub="- - - -"
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    /> 
                </div>


                <div className={cl.groupInput} style={{ display: 'flex', gap: '5px' }}>

                 

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" style={{fontWeight: '600'}}
                                className={validates && validates.gross_weight ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="gross_weight" name="gross_weight" value={newContainer.gross_weight} onChange={handleContainerChangeInt} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <Kilogram/>
                            </div>
                        </div>
                        <label htmlFor="gross_weight">წონა</label>
                    </div> 


                    <div className={cl.groupInput }>
                        <div className={cl.groupBorder}>
                            
                            <input
                                type="checkbox"
                                checked={newContainer.is_transit === 1}
                                onChange={(event) => {
                                    setNewContainer(prevState => ({
                                    ...prevState,
                                    is_transit: event.target.checked ? 1 : 0,
                                    }));
                                }}
                                /> კი
                            <label >ტრანზიტი</label>
                        </div>
                    </div>



            
                </div> 




                <div className={cl.groupInput}>
                    <DistatntionSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newContainer.final_destination_country_id}
                        childId={newContainer.final_destination_city_id}
                        isNetwork={true}
                        styles={selectDistatntionStyle}
                        onChange={async (final_destination_country_id, final_destination_city_id) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                final_destination_country_id: final_destination_country_id ? final_destination_country_id : 0,
                                final_destination_city_id: final_destination_city_id ? final_destination_city_id : 0,
                            }));
                        }}
                        join={"country_id"}
                        label="ფინალური დანიშ."
                        placeholder="- -"
                        placeholderSub="- - - -"
                        validate={validates && validates.final_destination_country_id ? true : false}
                        validateSub={validates && validates.final_destination_city_id ? true : false}
                        isDisabled={newContainer.is_transit && newContainer.is_transit == 1 ? false : true}
                    /> 
                </div>


                    
                <div className={validates && validates.land_type_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <Select
                        styles={validates && validates.land_type_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={typeOptions}
                        placeholder=""
                        isClearable
                        value={typeOptions.find(option => option.value === newContainer.land_type_id)}
                        onChange={(selectedOption) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                land_type_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                    <label >სახმელეთო გადაზიდვა</label>
                </div>
 
 
                

                <div className={ validates && validates.send_at ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                    <DateSelect
                        defDate={newContainer.send_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                send_at: date ? date : "",
                            }));
                        }}
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input}
                        isClearable={app.hasPermission("ADD_SEND_AT")}
                        isDisabled={!app.hasPermission("ADD_SEND_AT")}
                    />
                    <label>გამოსვლა</label>
                </div>
 
                <div className={cl.groupInput}>
                    <DateSelect
                        defDate={newContainer.entry_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                entry_at: date ? date : "",
                            }));
                        }}
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input}
                        isClearable={app.hasPermission("ADD_ENTRY_AT")}
                        isDisabled={!app.hasPermission("ADD_ENTRY_AT")}
                    />
                    <label>შემოსვლა</label>
                </div>

                <div className={cl.groupInput}>
                    <DateSelect
                        defDate={newContainer.open_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                open_at: date ? date : "",
                            }));
                        }}
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input}
                        isClearable={app.hasPermission("ADD_OPEN_AT")}
                        isDisabled={!app.hasPermission("ADD_OPEN_AT")}
                    />
                    <label>გახსნა</label>
                </div>

                <div className={cl.groupInput}>
                    <DateSelect
                        defDate={newContainer.taken_at}
                        onChange={(date) => {
                            setNewContainer(prevState => ({
                                ...prevState,
                                taken_at: date ? date : "",
                            }));
                        }}
                        placeholderText=""
                        popperClassName={cl.dataContainer}
                        wrapperClassName={cl.dataContainer}
                        className={cl.input}
                        isClearable={app.hasPermission("ADD_TAKEN_AT")}
                        isDisabled={!app.hasPermission("ADD_TAKEN_AT")}
                    />
                    <label>დასრულება</label>
                </div>
                <div className={cl.groupInput}>
                </div>
 

 
            </div>
 
 
           
 

 
            <div className={tbl.table + ' ' + cl.table} style={{position: 'relative', minHeight: 'unset', overflow: 'unset' }}>
                <table>
                    <thead>
                        <tr> 
                            <th>სახელი გვარი</th>
                            <th style={{ maxWidth: '70px', minWidth: '70px' }}>პირადი</th>
                            <th style={{ maxWidth: '70px', minWidth: '70px' }}>მობილური</th>
                            <th style={{ maxWidth: '155px', minWidth: '155px' }}>მანქანა</th>
                            <th style={{ minWidth: '106px' }}>VIN</th>
                            <th>გადასახდელი</th>
                            <th>გადახდილი</th>
                            <th>ვალი</th>
                            <th style={{ padding: '2px 5px', width: '5px' }}>
                                <span className={cl.AddBtnCargo}> 
                                    <span className={cl.icon} onClick={addCargo}><Plus /></span>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cargos.map((cargo, index) => ( 
                            <tr key={index}>
                                <td>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', position: 'relative' }}>
                                        <div className={validates && validates['name' + index] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                                            <input type="textS" className={cl.input} name="name" value={cargo.name} onChange={(e) => handleInputChange(e, index)}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                                }}
                                            /> 
                                        </div>  
                                    </div>
                                </td>

                                <td>
                                    <div className={validates && validates['personal' + index] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                                        <input type="textS" className={cl.input} name="personal" value={cargo.personal} onChange={(e) => handleInputChange(e, index)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                            }}
                                        /> 
                                    </div>
                                </td>

                                <td>  
                                    <div className={validates && validates['mobile' + index] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                                        <input type="textS" className={cl.input} name="mobile" value={cargo.mobile} onChange={(e) => handleInputChange(e, index)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                            }}
                                        />                                    
                                    </div>
                                </td>

                                
                                <td> 
                                    <div className={validates && validates[`car_info${index}`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                                        <input type="textS" className={cl.input}
                                            name="car_info" value={cargo.car_info} onChange={(e) => handleInputChange(e, index)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                            }}
                                        />
                                    </div>
                                </td>
 

                                <td> 
                                    <div className={validates && validates[`vin${index}`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                                        <input type="textS" className={cl.input}
                                            name="vin" value={cargo.vin} onChange={(e) => handleInputChange(e, index)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                            }}
                                        />
                                    </div> 
                                </td>


                                <td style={{ maxWidth: '85px' }}>      
                                    <div className={validates && validates[`cargo_price${index}`] ? cl.groupPrice + ' ' + cl.dollar + ' ' + cl.blue + ' ' + cl.errorInput : cl.groupPrice + ' ' + cl.dollar + ' ' + cl.blue} style={{ maxWidth: '75px' }}>
                                            <input type="textS" className={cl.input}
                                                onFocus={(e) => handleFocusCargo(e, index)} onBlur={(e) => handleBlurCargo(e, index)} onKeyPress={handleKeyPress}
                                                name="cargo_price" value={cargo.cargo_price} onChange={(e) => handleInputInt(e, index)}
                                            /> 
                                    </div>  
                                </td>

                                <td style={{ maxWidth: '85px' }}></td>

                                <td style={{ maxWidth: '85px' }}></td>

                                <td style={{width: '10px'}}>
                                    <span className={cl.AddBtnCargo}> 
                                        <span onClick={() => removeCargo(index)} className={cl.removeBtn}>
                                            <Remove/>
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        ))}

  
                        <tr>
                            <td style={{ textAlign: 'right' }} colSpan={1}>
                                {containerPrice && containerPrice.agent ? (
                                    <div>
                                        აგენტი: {containerPrice.agent.name} - {containerPrice.agent.number}
                                    </div>
                                ) : (
                                    <div></div>
                                )}

                            </td>
                            <td style={{ textAlign: 'right' }} colSpan={4}>კლიენტების ჯამი</td>
                            <td> 
                                {app.hasPermission("CLIENT_PRICE_SHOW") &&
                                    <>  

                                        <span style={{ marginRight: '5px' }} className={ cl.cargoPrice}   >
                                                {client_total_price}
                                        </span> 
 

                                        <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.client_frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="client_frast_price" name="client_frast_price" value={newContainer.client_frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                            <label htmlFor="client_frast_price">ფრახტი</label>
                                        </div>

                                        <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.client_thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="client_thc_price" name="client_thc_price" value={newContainer.client_thc_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                            <label htmlFor="client_thc_price">THC ფასი</label>
                                        </div>

                                        <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.client_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="client_other_price" name="client_other_price" value={newContainer.client_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                             <label htmlFor="client_other_price">სხვა</label>
                                        </div> 
 
                                        {newContainer.land_type_id === 0 ? (
                                            <></>
                                        ) : ( 
                                            <> 
                                                <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                                    <input type="textS"
                                                        className={validates && validates.client_land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                        id="client_land_price" name="client_land_price" value={newContainer.client_land_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                                    <label htmlFor="client_land_price">სახმელეთო</label>
                                                </div>

                                                <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                                    <input type="textS"
                                                        className={validates && validates.client_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                        id="client_land_other_price" name="client_land_other_price" value={newContainer.client_land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                                    <label htmlFor="client_other_price">სხვა</label>
                                                </div>
                                            </> 
                                        )}
 
                                    </>
                                }
                            </td>
                            <td>
                                {app.hasPermission("CLIENT_PAY_SHOW") &&
                                    <></>
                                }
                            </td>
                            <td>
                                {app.hasPermission("CLIENT_DEBT_SHOW") &&
                                    <></>
                                }
                            </td> 
                            <td> </td>  
                        </tr>
                            
                        <tr> 
                            <td style={{ textAlign: 'right' }} colSpan={5}>კომპანია</td>
                            <td style={{ maxWidth: '50px' }}> 
                                {app.hasPermission("COMPANY_PRICE_SHOW") &&
                                    <>

                                        <div style={{ color: '#df8805', fontWeight: 'bold' }}   >{company_total_price}</div> 


                                        <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="frast_price" name="frast_price" value={newContainer.frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                            <label htmlFor="frast_price">ფრახტი</label>
                                        </div>

                                        <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="thc_price" name="thc_price" value={newContainer.thc_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                            <label htmlFor="thc_price">THC ფასი</label>
                                        </div>

                                        <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                            <input type="textS"
                                                className={validates && validates.other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                id="other_price" name="other_price" value={newContainer.other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                            <label htmlFor="other_price">სხვა</label>
                                        </div>
                

                                        {newContainer.land_type_id === 0 ? (
                                            <></>
                                        ) : ( 
                                            <>
                    
                                                <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}> 
                                                    <input type="textS"
                                                        className={validates && validates.land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                        id="land_price" name="land_price" value={newContainer.land_price} onChange={handleContainerChangeInt} autoComplete="off" />                                                         
                                                    <label htmlFor="land_price"> სახმელეთო</label>
                                                </div>

                                                <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                                    <input type="textS"
                                                        className={validates && validates.company_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                                        id="land_other_price" name="land_other_price" value={newContainer.land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />                                                     
                                                    <label htmlFor="company_other_price">სხვა </label>
                                                </div>
                
                                            </> 
                                        )}


                                    </>
                                }    
                            </td>
                            <td>
                                {app.hasPermission("COMPANY_PAY_SHOW") &&
                                    <></>
                                }
                            </td>
                            <td>   
                                {app.hasPermission("COMPANY_DEBT_SHOW") &&
                                    <></>    
                                }
                            </td>
                            <td></td> 
                        </tr>


                    </tbody>
                </table>
            </div>



            <div className={cl.containerItem} style={{ marginTop: '15px' }}>
   
                     <>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }></div>
                        <div className={cl.groupInput }>
                            <span   className={cl.CancelBtn} onClick={onClose} >გაუქმება</span>
                        </div>
                        <div className={cl.groupInput }>
                            <span onClick={saveHandle} className={cl.YesBtn}>დამატება</span>
                        </div>
                    </>
   
            </div>
   

        </div>
    );
};

export default AddContainerModal;
